import * as Yup from 'yup';

export const APPOINTMENT_BY_MINUTE_VALIDATOR = Yup.object().shape({
  startTimeOffset: Yup.number()
    .required()
    .lessThan(Yup.ref('endTimeOffset'), 'Start time must be before end time'),
  endTimeOffset: Yup.number()
    .required()
    .moreThan(
      Yup.ref('startTimeOffset'),
      'End time must be after start time'
    ),
  id: Yup.string().required(),
  notes: Yup.string()
});
